export { default as BOTRegionalDetails } from '../BOTRegionalDetails/index'
export { default as BOTRegionLocations } from '../BOTRegionLocations/BOTRegionLocations'
